"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var styles_2 = __importDefault(require("./styles"));
var CompleteProfileModal = function (_a) {
    var show = _a.show, onClick = _a.onClick, onClose = _a.onClose;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(package_1.InformationDialog, { open: show, maxWidth: 'xs', onClose: onClose, hideXButton: true, hideButton: true, paperStyles: { maxWidth: '360px' } },
            react_1.default.createElement("div", { className: classes.mainDiv },
                react_1.default.createElement(Typography_1.default, { variant: "h6", component: "h1", color: 'textPrimary', gutterBottom: true, align: 'center', className: classes.bottomSpacing }, t('profile.completeProfile.title')),
                react_1.default.createElement(Typography_1.default, { variant: "body2", component: "h1", color: 'textPrimary', gutterBottom: true, align: 'center', className: classes.bottomSpacing }, t('profile.completeProfile.note')),
                react_1.default.createElement("div", { className: classes.buttonContainer },
                    react_1.default.createElement(Button_1.default, { className: classes.buttonStyle, size: "large", variant: "contained", color: "primary", "aria-label": "Open Profile", onClick: onClick }, t('profile.completeProfile.openProfile')))))));
};
exports.default = CompleteProfileModal;
//# sourceMappingURL=CompleteProfileModal.js.map